import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'default',
    redirect: { name: 'orders' },
    meta: {
      // authRequired: true,
    },
    //component: () => import('./views/dashboard/default'),
  },
  {
    path: '/orders',
    name: 'orders',
    //meta: { authRequired: true },
    component: () => import('./views/orders/default')
  },
  {
    path: '/orders/csv',
    name: 'orders-csv',
    //meta: { authRequired: true },
    component: () => import('./views/orders/csv')
  },
  {
    path: '/orders/:id',
    name: 'orders-id',
    props: true,
    //meta: { authRequired: true },
    component: () => import('./views/orders/id')
  },
  {
    path: '/orders/create',
    name: 'orders-create',
    props: false,
    //meta: { authRequired: true },
    component: () => import('./views/orders/id')
  },
  {
    path: '/orders/shipping/:id',
    name: 'orders-shipping-id',
    props: true,
    //meta: { authRequired: true },
    component: () => import('./views/orders/shipping')
  },
  {
    path: '/orders/seatmap/:id',
    name: 'orders-seatmap-id',
    props: true,
    //meta: { authRequired: true },
    component: () => import('./views/orders/tickets')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('./views/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch('auth/logOut')
        } else {
          store.dispatch('authfack/logout')
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
 
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
 
]
